import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className combiner. Use this for any conditional class logic
 * so duplicates/conflicting utilities are resolved.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
